import request from '@/api/req/request'

/* 上传身份证*/
export function upz(idCardImg) {
  return request.post('/index/user/uploadIdCard', idCardImg )
}

/* 上传头像*/
export function upheade(avatar) {
  return request.post('/index/user/editAva', avatar )
}

/* 访问日志*/
export function upTime(task_id) {
  return request.post('/index/index/visitLog', {
    task_id
  } )
}